import React from 'react';
import { Card, CardActionArea, Typography, Box } from '@mui/material';

const ProjectCard = ({ img_src, title, date, sx, onClick }) => {
  return (
    <Card
      sx={{
        // width,
        // height,
        // backgroundColor: 'red',
        border: '1px solid #cccccc', 
        borderRadius: '12px',
        overflow: 'hidden',
        boxShadow: 'none',
        border: 'none',
        ...sx, 
        // boxShadow: 3,
      }}
    >
      <CardActionArea
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        onClick={onClick}
      >
        <Box
          component="img"
          src={img_src}
          alt="project preview"
          sx={{
            width: '100%',
            aspectRatio: '16/12',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
        <Box sx={{ mt: 1, pl: 2, py: 1, height: '18%', width: '100%' }}>
          <Typography variant="subtitle1" fontWeight="bold">
            {title}
          </Typography>
          <Typography variant="subtitle2" color="text.secondary">
            Modified on {date}
          </Typography>
        </Box>
      </CardActionArea>
    </Card>
  );
};

export default ProjectCard;
